export const configKeys = {
  /**
   * Config key for workflow uri
   * @type {string}
   */
  WORKFLOW_API_URI_CONFIG_KEY: 'apis.workflow.uri',

  /**
   * Config key for questionnaire api uri
   * @type {string}
   */
  QUESTIONNAIRE_URI_CONFIG_KEY: 'apis.questionnaire.uri',

  /**
   * Config key for patient api uri
   * @type {string}
   */
  PATIENT_URI_CONFIG_KEY: 'apis.patient.uri',

  /**
   * Config key for session auth token
   * @type {string}
   */
  SESSION_AUTH_TOKEN: 'session.authToken',

  /**
   * Config key for session tenant id
   * @type {string}
   */
  SESSION_TENANT_ID: 'session.tenantId',

  /**
   * Config key for settings api uri
   * @type {string}
   */
  SETTINGS_URI_CONFIG_KEY: 'apis.settings.uri'
};
